module.exports = __webpack_public_path__ + "static/img/bhplogo.718b7e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bhplogo.png
// module id = fRff
// module chunks = 175